import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { betterGrade, type Grade } from '@strategy4kids/lessons';

interface ProgressStore {
  /** Best grade earned per lesson id. */
  readonly best: Readonly<Record<string, Grade>>;
  readonly onboardingDone: boolean;
  recordResult(lessonId: string, grade: Grade): void;
  /** Merge server-stored best grades, keeping the better of the two per lesson. */
  mergeServerBest(server: Readonly<Record<string, Grade>>): void;
  finishOnboarding(): void;
}

export const useProgressStore = create<ProgressStore>()(
  persist(
    (set) => ({
      best: {},
      onboardingDone: false,
      recordResult(lessonId, grade) {
        set((s) => {
          const prev = s.best[lessonId];
          return { best: { ...s.best, [lessonId]: prev ? betterGrade(prev, grade) : grade } };
        });
      },
      mergeServerBest(server) {
        set((s) => {
          const merged = { ...s.best };
          for (const [id, grade] of Object.entries(server)) {
            const prev = merged[id];
            merged[id] = prev ? betterGrade(prev, grade) : grade;
          }
          return { best: merged };
        });
      },
      finishOnboarding() {
        set({ onboardingDone: true });
      },
    }),
    { name: 's4k:progress' },
  ),
);
